import { WatsonHealthRotate_360 } from '@carbon/icons-react';
import { useEffect, useState } from 'react';
import { useNavigation } from 'react-router';
import { useSpinDelay } from 'spin-delay';

function GlobalProgress() {
  const transition = useNavigation();
  const busy = transition.state !== 'idle';
  // Much shorter delays for responsive SPA
  const delayedPending = useSpinDelay(busy, {
    delay: 0, // Show immediately for ultra-fast navigation
    minDuration: 100, // Stay visible for 100ms minimum
  });

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (delayedPending) {
      // Start progress immediately
      setProgress(20);

      // Update progress based on navigation state
      const timer = setTimeout(() => {
        if (transition.state === 'submitting') {
          setProgress(60);
        } else if (transition.state === 'loading') {
          setProgress(80);
        }
      }, 100);

      return () => clearTimeout(timer);
    } else {
      // Complete and reset
      setProgress(100);
      const timer = setTimeout(() => setProgress(0), 150);
      return () => clearTimeout(timer);
    }
  }, [delayedPending, transition.state]);

  if (!delayedPending) return null;

  return (
    <div
      role="progressbar"
      aria-valuetext="Loading"
      className="fixed inset-x-0 left-0 top-0 h-[0.20rem]"
      style={{
        zIndex: 10000,
        backgroundColor: 'var(--cds-layer-02, #f4f4f4)',
      }}
    >
      <div
        className="h-full transition-all duration-300 ease-out"
        style={{
          width: `${progress}%`,
          backgroundColor: 'var(--cds-interactive-01, #e4695f)',
        }}
      />
      {delayedPending && (
        <div className="absolute flex items-center justify-center">
          <WatsonHealthRotate_360
            size={20}
            style={{ color: '#e4695f' }}
            className="m-1 animate-spin text-primary"
            aria-hidden
          />
        </div>
      )}
    </div>
  );
}

export { GlobalProgress };
